import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';

function Todo() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);



	return (


		<>
			<Helmet>
				<title>Manage Your Tasks with Top Todo List Software | Taskflier </title>
			</Helmet>

    <div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
          <div class="pl-lg-5">
            <div class="title-style-fourteen">
              <h6><span class="upper-title custom-name">TO-DO LIST</span></h6>
              <h1>Stay Organized with  TaskFlier’s To-Do List</h1>
            </div>
            <div class="tag-line">The To-Do List feature of TaskFlier streamlines task management like never before. From organizing daily activities and customizing notification settings to tracking key project milestones, To-Do List empowers you and your team to stay focused, organized, and productive—enabling you to manage everything efficiently on one centralized platform.
            </div>
           
          </div>
        </div>
        <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
          <div class=" d-inline-block md-mt-60">
            <img src="/main/images/todo-bg.jpg" alt="Stay Organized" class="w-100"/>
          
          </div>
        </div>
      </div>
    </div>
  </div>

				<div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
					<div class="container">
						<div class="title-style-two text-center mb-40 md-mb-40">

							<h3 class="maintitle "><span>Benefits of TaskFlier’s To-Do List </span></h3>

						</div>

						<div class="row  features">


							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/task-one.png" alt="Task creation" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Easy Task Creation and Assignment</div>
									<hr></hr>
									<p className='mainp'>Quickly add new tasks and assign them to appropriate team members. Affix a clear due date and level of priority to each task. Add detailed instructions and notes to keep everything consistent and live.
									</p>

								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/todo-list2.png" alt="Set Reminders and Deadlines" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Set Reminders and Deadlines
									</div>
									<hr></hr>
									<p className="mainp">Stay connected in real-time with customizable reminders that notify group participants of cut-off dates drawing near. Enable notifications to hold all and sundry updates on urgent tasks, supporting the team's stay on course.</p>

								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/todo-list3.png" alt="Collaborative Performance" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Collaborative Performance Management</div>
									<hr></hr>
									<p className="mainp">Promote team collaboration with explicit delegation of tasks to team members. Allow team members to comment, add notes, and update workflows. Improve your team's productivity by posting work information and keeping everyone informed, on the fly.</p>


								</div>
							</div>

							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/todo-list4.png" alt="Customizable Categories" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Customizable Categories and Tags</div>
									<hr></hr>
									<p className="mainp">Organize your tools with customizable categories, icons, and labels to quickly filter, search, and find what you need. Differentiate between different project tasks. Easily simplify and organize management of complex projects.</p>


								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/todo-list5.png" alt="Daily and Weekly" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Daily and Weekly Task Overviews
									</div>
									<hr></hr>
									<p className="mainp">View periodic (daily and weekly) and live summary leaving you and your team focus on what matters most. Start each day or week with a clear understanding of what is coming up ahead and make adjustments as necessary, on the go.</p>

								</div>

							</div>
						</div>
					</div>
				</div>

				<div class="fancy-feature-thirtySeven bg-white lg-container pb-80 pt-100 " id="stories">
					<div class="block-style-fortyOne">
						<div class="container">
							<div class="row align-items-center">
								<div class="col-lg-5 aos-init aos-animate" data-aos="fade-right">

									<div class="title-style-two text-center mb-20 ">
										<h3 class="maintitle text-left">Do more with TaskFlier's To-Do feature</h3>
										<div class="sub-text mt-0 pt-1 maxsubtitle text-left"><strong>With TaskFlier's to-do list, you can easily:</strong></div>
									</div>


									<ul class="bullet">

										<li>create, assign, and track all your tasks</li>
										<li>help your team be more productive and get things done on time</li>
										<li>manage priorities and meet deadlines</li>
										<li>keep everyone connected and productive</li>
										<li>each your goals faster</li>
										<li>achieve optimum throughput</li>

					</ul>
								
							</div>
							<div class="col-lg-6 col-lg-offset-1 ml-auto text-center text-lg-right aos-init aos-animate" data-aos="fade-left">
								<div class="img-holder md-mt-50 d-inline-block"><img src="/main/images/todo-points.png" alt="To-Do feature"/></div>
							</div>
						</div>
					</div>
				</div>
			
			
			</div>




				<CoreFeature />
				<div className="faq-classic pt-0 bg-white">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="title-style-one mb-40">
									<h6 className="font-rubik">Find your answers</h6>
									<h2>Have any thought? Look here.</h2>
								</div>
							</div>
							<div className="col-lg-12">
								<div id="accordion" className="md-mt-60">
									<div className="card">
										<div className="card-header" id="headingOne">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseOne"
													aria-expanded="true"
													aria-controls="collapseOne"
												>
													What is the To Do List feature, and how does it help in a business environment?
												</button>
											</h5>
										</div>
										<div
											id="collapseOne"
											className="accordion-collapse collapse show"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													The To Do List is a task management tool designed to help managers and teams organize work efficiently. It provides a clear structure for assigning, tracking, and completing tasks, ensuring better workflow, accountability, and time management</p>
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingTwo">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseTwo"
													aria-expanded="true"
													aria-controls="collapseTwo"
												>
													Can tasks be assigned to specific team members?
												</button>
											</h5>
										</div>
										<div
											id="collapseTwo"
											className="accordion-collapse collapse "
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>Yes. You can easily assign tasks to individuals or groups within your organization. Each task can include details such as deadlines, priority levels, and instructions to help streamline execution.</p>
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingThree">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseThree"
													aria-expanded="true"
													aria-controls="collapseThree"
												> Does the system support recurring tasks’ assignment?
												</button>
											</h5>
										</div>
										<div
											id="collapseThree"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Yes. You can set up recurring tasks for daily, weekly, or monthly intervals. This is particularly useful for routine activities such as reporting, follow-ups, or team meetings.
												</p>

											</div>
										</div>
									</div>


									<div className="card">
										<div className="card-header" id="headingfour">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseFour"
													aria-expanded="true"
													aria-controls="collapseFour"
												>
													How does the reminder system work?
												</button>
											</h5>
										</div>
										<div
											id="collapseFour"
											className="accordion-collapse collapse "
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>The To Do List includes automatic reminders via email and in-app notifications. You’ll receive alerts for upcoming deadlines, overdue tasks, or important updates, keeping everyone on schedule.</p>
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingFive">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseFive"
													aria-expanded="true"
													aria-controls="collapseFive"
												> Is the To Do List feature mobile-friendly?
												</button>
											</h5>
										</div>
										<div
											id="collapseFive"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Yes. TaskFlier is available on web, iOS, and Android, allowing users to view, update, or complete tasks on the go. It’s optimized for mobile use to support remote and field teams.
												</p>

											</div>
										</div>
									</div>


								</div>
							</div>
						</div>
					</div>
				</div>
		</>

	)
}

export default Todo
